export default __webpack_public_path__ + "static/xcad-wallet-e1ddfe604d583d28685c063f8d480749.png";